import React, { useEffect, useState } from "react";
import { TextField, Button, Stepper, Step, StepLabel } from "@material-ui/core";
import {
  useForm,
  Controller,
  FormProvider,
  useFormContext,
} from "react-hook-form";
import { Link } from "react-router-dom";
import { AiOutlineArrowRight, AiOutlineArrowLeft } from "react-icons/ai";
import { BsArrowCounterclockwise } from "react-icons/bs";
import { auth } from "../../firebase.init";
import { useCreateUserWithEmailAndPassword } from "react-firebase-hooks/auth";
import { toast } from "react-toastify";
import axios from "axios";
import useUsers from "../../hooks/useUsers";

function getSteps() {
  return ["Credentials", "Contact", "Personal Info"];
}
const BasicForm = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();


  const today = new Date();
  const tomorrow = new Date(today)
  tomorrow.setDate(tomorrow.getDate() - 7300);
  const minDate = tomorrow.toISOString().split("T")[0];
  //console.log(minDate);

  return (
    <>
      <Controller
        control={control}
        name="name"
        rules={{ required: "This field is required." }}
        render={({ field }) => (
          <TextField
            id="name"
            label="Full Name"
            variant="outlined"
            placeholder="Enter Your Full Name"
            fullWidth
            margin="normal"
            {...field}
            error={Boolean(errors?.name)}
            helperText={errors.name?.message}
          />
        )}
      />

      <Controller
        control={control}
        name="email"
        rules={{ required: "This field is required." }}
        render={({ field }) => (
          <TextField
            type="email"
            id="email"
            label="Email Address"
            variant="outlined"
            placeholder="Enter Email Address"
            fullWidth
            margin="normal"
            {...field}
            error={Boolean(errors?.email)}
            helperText={errors.email?.message}
          />
        )}
      />

      <Controller
        control={control}
        name="password"
        rules={{ required: "This field is required." }}
        render={({ field }) => (
          <TextField
            type="password"
            id="password"
            label="Password"
            variant="outlined"
            placeholder="Create A New Password"
            fullWidth
            margin="normal"
            {...field}
            error={Boolean(errors?.password)}
            helperText={errors.password?.message}
            inputProps={{ minLength: 8 }}
          />
        )}
      />
    </>
  );
};
const ContactForm = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Controller
        control={control}
        name="phone"
        rules={{ required: "This field is required." }}
        render={({ field }) => (
          <TextField
            id="phone"
            label="Phone Number"
            variant="outlined"
            placeholder="Enter Your Phone Number"
            fullWidth
            margin="normal"
            {...field}
            error={Boolean(errors?.phone)}
            helperText={errors.phone?.message}
          />
        )}
      />

      <Controller
        control={control}
        name="city"
        rules={{ required: "This field is required." }}
        render={({ field }) => (
          <TextField
            id="city"
            label="City Name"
            variant="outlined"
            placeholder="Enter Your Present City"
            fullWidth
            margin="normal"
            {...field}
            error={Boolean(errors?.city)}
            helperText={errors.city?.message}
          />
        )}
      />

      <Controller
        control={control}
        name="division"
        rules={{ required: "This field is required." }}
        render={({ field }) => (
          <TextField
            id="division"
            label="Division/State"
            variant="outlined"
            placeholder="Enter Your Present Division"
            fullWidth
            margin="normal"
            {...field}
            error={Boolean(errors?.division)}
            helperText={errors.division?.message}
          />
        )}
      />
    </>
  );
};
const PersonalForm = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Controller
        control={control}
        name="nid"
        rules={{ required: "This field is required." }}
        render={({ field }) => (
          <TextField
            type="number"
            id="nid"
            label="Nid Number"
            variant="outlined"
            placeholder="Enter Your NID Number"
            fullWidth
            margin="normal"
            {...field}
            error={Boolean(errors?.nid)}
            helperText={errors.nid?.message}
          />
        )}
      />

      <Controller
        control={control}
        name="dob"
        rules={{ required: "This field is required." }}
        render={({ field }) => (
          <TextField
            InputProps={{ inputProps: { min: "1950-05-01", max: "2004-05-04" } }}
            type="date"
            id="dob"
            label="Date of Birth"
            variant="outlined"
            fullWidth
            margin="normal"
            {...field}
            error={Boolean(errors?.dob)}
            helperText={errors.dob?.message}
          />
        )}
      />

      <Controller
        control={control}
        name="pcode"
        rules={{ required: "This field is required." }}
        render={({ field }) => (
          <TextField
            type="number"
            id="pcode"
            label="Postal Code"
            variant="outlined"
            placeholder="Enter Your Postal Code"
            fullWidth
            margin="normal"
            {...field}
            error={Boolean(errors?.pcode)}
            helperText={errors.pcode?.message}
          />
        )}
      />
    </>
  );
};
function getStepContent(step) {
  switch (step) {
    case 0:
      return <BasicForm />;
    case 1:
      return <ContactForm />;
    case 2:
      return <PersonalForm />;
    default:
      return "unknown step";
  }
}

const MultiStepper = () => {
  const methods = useForm({
    defaultValues: {
      name: "",
      img: "https://cdn-icons-png.flaticon.com/512/3899/3899618.png",
      email: "",
      password: "",
      bio: "",
      speaks: "English",
      rating: 0.0,
      noRating: 0,
      noTour: 0,
      phone: "",
      city: "",
      division: "",
      nid: "",
      dob: "",
      pcode: "",
      role: "user",
    },
  });

  const [activeStep, setActiveStep] = useState(0);

  const steps = getSteps();

  const [createUserWithEmailAndPassword, user, loading, hookError] =
    useCreateUserWithEmailAndPassword(auth, { sendEmailVerification: true });

  const handleAddUser = async (newUser) => {
    await axios.post("https://tripaide-server.onrender.com/users", newUser)
      .then(res => {
        //console.log(res.data);
      });
  };

  const [users] = useUsers();

  const handleNext = (data) => {
    if (data.pcode !== "") {
      createUserWithEmailAndPassword(data.email, data.password);
      const status = users?.find(u => u.email === data.email);
      if (status === undefined) {
        handleAddUser(data);
      }
    }
    setActiveStep(activeStep + 1);
  };

  useEffect(() => {
    if (hookError) {
      //console.log(hookError?.code);
      switch (hookError?.code) {
        case "auth/email-already-in-use":
          toast.error("Email is already registered.");
          break;
        default:
          toast.error("Something went wrong.");
      }
    }
  }, [hookError]);

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  return (
    <div>
      <Stepper
        className="text-yellow-500"
        alternativeLabel
        activeStep={activeStep}
      >
        {steps.map((step, index) => {
          const labelProps = {};
          const stepProps = {};

          return (
            <Step
              sx={{
                "& .MuiStepLabel-root .Mui-completed": {
                  color: "#EAB308", // circle color (COMPLETED)
                },
                "& .MuiStepLabel-root .Mui-active": {
                  color: "#EAB308", // circle color (ACTIVE)
                },
              }}
              className="text-yellow-500"
              {...stepProps}
              key={index}
            >
              <StepLabel className="text-yellow-500" {...labelProps}>
                {step}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>

      {activeStep === steps.length ? (
        hookError ? (
          <div className="container md:mt-10">
            <div className="flex flex-col items-center">
              <div className="wrapper">
                <svg
                  className="checkmark"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 52 52"
                >
                  <circle
                    className="checkmark__circle"
                    cx="26"
                    cy="26"
                    r="25"
                    fill="none"
                  />
                  <path className="checkmark__check" fill="none" d="" />
                </svg>
              </div>

              <div className="mt-3 text-4xl font-semibold text-red-500">
                Warning!
              </div>
              <div className="text-lg font-semibold text-gray-500">
                {hookError.code.slice(hookError.code.indexOf("/") + 1)}
              </div>
              <Link className="mt-10" to="/login">
                <button className="flex items-center py-auto h-10 px-5 text-yellow-500 transition-colors duration-150 border border-yellow-500 rounded-lg focus:shadow-outline hover:bg-yellow-500 hover:text-white">
                  Back to Login
                  <BsArrowCounterclockwise className="ml-2" />
                </button>
              </Link>
            </div>
          </div>
        ) : (
          <div className="container md:mt-10">
            <div className="flex flex-col items-center">
              <div className="wrapper">
                <svg
                  className="checkmark"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 52 52"
                >
                  <circle
                    className="checkmark__circle"
                    cx="26"
                    cy="26"
                    r="25"
                    fill="none"
                  />
                  <path
                    className="checkmark__check"
                    fill="none"
                    d="M14.1 27.2l7.1 7.2 16.7-16.8"
                  />
                </svg>
              </div>

              <div className="mt-3 text-xl font-semibold text-yellow-500">
                Congratulations!
              </div>
              <div className="text-lg font-semibold text-gray-500">
                Your Account has been created
              </div>
              <Link className="mt-10" to="/editprofile">
                <button className="flex items-center py-auto h-10 px-5 text-yellow-500 transition-colors duration-150 border border-yellow-500 rounded-lg focus:shadow-outline hover:bg-yellow-500 hover:text-white">
                  Complete Profile
                  <AiOutlineArrowRight className="ml-2" />
                </button>
              </Link>
            </div>
          </div>
        )
      ) : (
        <>
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(handleNext)}>
              {getStepContent(activeStep)}

              <div className="flex justify-between my-4">
                <Button
                  className="block bg-gray-400 text-white flex"
                  disabled={activeStep === 0}
                  onClick={handleBack}
                >
                  <AiOutlineArrowLeft className="mr-2" />
                  Back
                </Button>

                <Button
                  className="block bg-yellow-500 flex"
                  variant="contained"
                  type="submit"
                >
                  {activeStep === steps.length - 1 ? "Finish" : "Next"}
                  <AiOutlineArrowRight className="ml-2" />
                </Button>
              </div>
            </form>
          </FormProvider>
        </>
      )}
    </div>
  );
};

export default MultiStepper;
